import React, { useState, useEffect, useRef } from 'react';
import style from './EmotionWriteList.module.css';
import HeadSub from '../../../../../components/comm/HeadSub';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import URL from '../../../../../constants/url';
import data_emotion from './data_emotion.json';

import axiosApi from '../../../../../api/daonAxios';
import CODE from '../../../../../constants/code';

const EmotionWriteList = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const survey_data = data_emotion[0];
    const outline = survey_data.outline;
    const surveyList = survey_data.surveyList;
    const totalSteps = surveyList.length;  // 설문 항목 개수
    const [selectedValues, setSelectedValues] = useState({});
    const fetchedRef = useRef(false);
    const usrSrveyRsltId = location.state?.usrSrveyRsltId

    
    //날짜 파싱
    const date = location.state?.date
    const year = parseInt(date.substring(0, 4), 10);
    const month = parseInt(date.substring(4, 6), 10) - 1; // 월은 0부터
    const day = parseInt(date.substring(6, 8), 10);
    const targetDate = new Date(year, month, day);
    const weekNames = ["일", "월", "화", "수", "목", "금", "토"];
    const dayOfWeek = weekNames[targetDate.getDay()];
    const formattedDate = `${year}.${String(month + 1).padStart(2, '0')}.${String(day).padStart(2, '0')}`;

    useEffect(() => {
        if (fetchedRef.current) return;
        fetchedRef.current = true;
        fetchSubmittedData();
    }, []);

    // 제출기록 조회
    const fetchSubmittedData = async () => {
        const loginUser = JSON.parse(sessionStorage.getItem("loginUser"));
        console.log("========> usrInfoId: ", loginUser.usrInfoId);
        const url = "/homecare/srvey/retrieveUsrSrveySbmtList"
        const jToken = localStorage.getItem('jToken');
        const reqBody = {
                    usrSrveyRsltId: usrSrveyRsltId
                };
        const reqOptions = {
            headers: {
                Authorization: jToken,
            }
        };
        try {
            const res = await axiosApi.post(url, reqBody, reqOptions);
            console.log(res);
            const resultList = res.data.result.resultList || [];
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                // selectedValues 초기값 구성
                const selectedMap = {};
                resultList.forEach(ans => {
                    const key = `q${ans.qesitmNo}`;
                    selectedMap[key] = {
                        value: ans.answrArry,
                        markVal: ans.markVal
                    };
                });
                setSelectedValues(selectedMap);
            } else {
                alert(res.data.resultMessage);
            }
            
        } catch (err) {
            console.error("제출기록 조회 중 오류", err);
        }
    };

    return (
        <>
            <HeadSub title={outline.title} />
 
            <div id="sub-content" data-layout="white">
                <div className="inner-wrap">

                <div className={style['top-title-box']}>
                    <p>{formattedDate} ({dayOfWeek})</p>   {/* 날짜 파싱 필요 */}
                </div>
                
                <div className={style['emotion-write-box']}>
                    <ul>
                        {surveyList.map((item, idx) => {
                        const selected = selectedValues[item.name]; // 예: selectedValues.q1
                        const selectedVals = Array.isArray(selected?.value)
                            ? selected.value
                            : selected?.value
                            ? [selected.value]
                            : [];

                        const selectedLabels = selectedVals
                            .map(val => item.options.find(opt => opt.value === val)?.label)
                            .filter(label => label)  // null 제거

                        const displayLabel = selectedLabels.length > 0
                            ? selectedLabels.join(", ")
                            : "미응답";
                        return (
                            <li key={item.id}>
                            <p><b>{String(idx + 1).padStart(2, '0')}.</b> {item.question}</p>
                            <span>{displayLabel}</span>
                            <button
                                className="btn"
                                data-btn-type="outline-main"
                                data-btn-size="xsm"
                                onClick={() =>
                                navigate(URL.EMOTION_WRITE, {
                                    state: {
                                    step: idx + 1,
                                    selectedValues: selectedValues,
                                    usrSrveyRsltId: usrSrveyRsltId,
                                    date : formattedDate
                                    }
                                })
                                }
                            >
                                <span>수정</span>
                            </button>
                            </li>
                        );
                        })}
                    </ul>
                </div>                  

                        
                </div>
            </div>
        </>
    );
};

export default EmotionWriteList;
